<!--Copy right - © 2024 tecera gmbh-->
<script>
    import RegisterForm from "../components/forms/RegisterForm.svelte";

</script>

<svelte:head>
    <title>myBach | Registrieren</title>
</svelte:head>

<div class="background-container">
        <RegisterForm />
</div>
